var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcceptCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#31F8C9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_125_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0211 25.0339V28.0339C40.0222 28.3124 39.9652 28.588 39.8536 28.8432C39.7421 29.0984 39.5784 29.3275 39.3732 29.5157C39.168 29.704 38.9257 29.8473 38.6619 29.9366C38.398 30.0258 38.1185 30.0589 37.8411 30.0339C34.7639 29.6995 31.8081 28.648 29.2111 26.9639C26.7949 25.4285 24.7464 23.38 23.2111 20.9639C21.5211 18.3551 20.4694 15.3849 20.1411 12.2939C20.1161 12.0173 20.149 11.7386 20.2376 11.4755C20.3262 11.2124 20.4687 10.9706 20.6559 10.7655C20.8431 10.5604 21.0709 10.3966 21.3249 10.2844C21.5789 10.1722 21.8535 10.1141 22.1311 10.1139H25.1311C25.6164 10.1091 26.0869 10.2809 26.4549 10.5974C26.8228 10.9139 27.0632 11.3533 27.1311 11.8339C27.2577 12.7939 27.4926 13.7366 27.8311 14.6439C27.9657 15.0018 27.9948 15.3908 27.915 15.7647C27.8353 16.1387 27.65 16.482 27.3811 16.7539L27.1889 16.9461C26.5523 17.5827 26.409 18.5743 26.9265 19.311C27.9903 20.8258 29.3092 22.1446 30.8239 23.2085C31.5607 23.726 32.5523 23.5827 33.1889 22.9461L33.3811 22.7539C33.653 22.485 33.9963 22.2997 34.3702 22.22C34.7442 22.1402 35.1332 22.1693 35.4911 22.3039C36.3984 22.6424 37.341 22.8772 38.3011 23.0039C38.7869 23.0724 39.2305 23.3171 39.5476 23.6914C39.8648 24.0656 40.0333 24.5434 40.0211 25.0339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_125_1649",
    x: 18.133,
    y: 9.11377,
    width: 23.8887,
    height: 23.9282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_125_1649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_125_1649",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptCall);
export default __webpack_public_path__ + "static/media/accept_call.07c5c60d87dc169135ed6ba435c33bc4.svg";
export { ForwardRef as ReactComponent };